import React from "react";
import { useNavigate } from "react-router-dom";
import FeaturedRecipBut from "./FeaturedRecipBut";
import UserMan from "./UserManBut";
import AnalyticBut from "./AnalyticsBut";

const AdminSidePanel = () => {
    
    return (
      <div style={{ display: 'flex', flexDirection: 'column' , gap: '20px' }}>
        <FeaturedRecipBut />
        <UserMan />
        <AnalyticBut />
      </div>
    );
};

export default AdminSidePanel;